import { APP_COMPANY } from "../../_Config/_Company/_Company";
import { OBJECT_FREEZE_HELPER } from "../../HELPERS/objectFreeze.helper";

const API_VERSION = "v1";

/*
 * PORTFOLIO - RESOLUCION AUTOMATICA DE ENTORNO
 * --------------------------------------------
 * localhost / 127.0.0.1 -> backend local de Laragon
 * cualquier otro host   -> backend de produccion en Hostinger
 *
 * De esta forma no hay que editar este archivo cada vez que se hace deploy.
 */
const CURRENT_HOSTNAME = typeof window !== "undefined" ? window.location.hostname : "";
const IS_LOCAL_RUNTIME = CURRENT_HOSTNAME === "localhost" || CURRENT_HOSTNAME === "127.0.0.1";

const BACKEND_MODE = IS_LOCAL_RUNTIME ? "LOCAL" : "PRODUCTION_DOMAIN";

const HOST_LOCAL = "http://localhost:4000";
const HOST_PRODUCTION = "https://bailador-project.com";

// El backend local conserva el namespace tecnico historico.
const LOCAL_API_PATH = `/${APP_COMPANY.COMPANY_SLUG}/api`;

// En Hostinger el backend vive fisicamente en public_html/portfolio-api.
const PRODUCTION_API_PATH = "/portfolio-api";

const ENDPOINTS = {
    LOCAL: {
        API: `${HOST_LOCAL}${LOCAL_API_PATH}`,
        SOCKET: HOST_LOCAL,
        STATIC: HOST_LOCAL,
    },

    PRODUCTION_DOMAIN: {
        API: `${HOST_PRODUCTION}${PRODUCTION_API_PATH}`,
        SOCKET: HOST_PRODUCTION,
        STATIC: `${HOST_PRODUCTION}${PRODUCTION_API_PATH}`,
    },
};

const ACTIVE = ENDPOINTS[BACKEND_MODE];

const _SCHEMA = {
    BACKEND_MODE,
    API_VERSION,
    API_URL: ACTIVE.API,
    SOCKET_URL: ACTIVE.SOCKET,
    STATIC_URL: ACTIVE.STATIC,
    ENDPOINTS,
};

export const API_BASE = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);
